import i18next from 'i18next';

i18next.addResources('es', 'projects', {
  activity: 'Proyectos financiados por los bancos de la Alianza relevantes para la integración de ALC',
  title: 'Proyectos',
  showMap: 'Mostrar mapa',
  showList: 'Mostrar grilla',
  textMapFilter: 'Buscar mientras muevo en el mapa'
});
